import { useSelector as useNativeSelector} from 'react-redux';

export const useSelector = useNativeSelector;